//const Backofficebff: string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
export const MenuCommand: any = {
    PostMenuAdd: Backofficebff + '/v1/menu/item/add',
    PostMenuCopy: Backofficebff + '/v1/menu/item/copy',
    PostMenuItemRoleAdd: Backofficebff + '/v1/menu/item-role/add',
    PutMenuUpdate: Backofficebff + '/v1/menu/item/update',
    DeleteMenu: Backofficebff + '/v1/menu/item',
    DeleteMenuApplication: Backofficebff + '/v1/menu/menu-application',
    PutMenuApplicationUpdate: Backofficebff + '/v1/menu/menu-application/update',
    MenuApplicationAdd: Backofficebff + '/v1/menu/menu-application/add',
};
